export default __webpack_public_path__ + "static/media/dessert.951a3fba.jpg";